module.exports = __webpack_public_path__ + "images/common/facebook.b4ba203a.svg";